import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link, NavLink, useHistory, useLocation } from "react-router-dom";
import logo2 from "../public/logo2.png";
import "./css/register.css";
import "./ui/theme.css";
import styles from "./Header.module.scss";
import { useTranslation } from "react-i18next";
import LanguageSelection from "../component/LanguageSelection";
import { useSelector, useDispatch } from "react-redux";
import useFetch from "./CustomHooks/useFetch";
import { logout } from "../Redux/actions/actionCreator/data.action";
import DropDownMenu from "../GeneralComponents/DropDownMenu";
import { useQueryClient } from "react-query";

function Header() {
	const [activePill, setActivePill] = useState("childManagement");
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const allowedData = useSelector((state) => state.config).config || [];
	const location = useLocation();
	const history = useHistory();
	const dropdownRef = useRef(null);
	const { t } = useTranslation();

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setIsMenuOpen(false);
			}
		};
		document.addEventListener("mousedown", handleClickOutside);
		return () => document.removeEventListener("mousedown", handleClickOutside);
	}, []);

	useEffect(() => {
		const val = location.pathname.split("/")[1];
		if (val === "myDaycareNew") {
			setActivePill("daycare");
		} else if (val === "pnl") {
			setActivePill("reports");
		} else if (val === "staffmanagement") {
			setActivePill("staffManagement");
		} else if (val === "mealmanagement") {
			setActivePill("mealManagement");
		} else if (val === "activity") {
			setActivePill("activities");
		} else {
			setActivePill(val);
		}
	}, [location.pathname]);

	useEffect(() => {
		setIsMenuOpen(false);
	}, [location.pathname]);

	useFetch({
		url: "/admin/manager/editLabels",
		method: "POST",
		body: JSON.stringify({
			daycareManagerEmail: "contact@stepswatch.co.in",
			payload: {},
		}),
	});

	const dispatch = useDispatch();
	const queryClient = useQueryClient();
	const handleLogout = () => {
		queryClient.invalidateQueries();
		dispatch(logout());
		localStorage.removeItem("token");
		localStorage.removeItem("config");
	};

	const gotoProfile = () => {
		if (localStorage.getItem("accountType") !== "professional") {
			history.push("/myDaycareNew/details");
		} else {
			history.push("/staffmanagement/profile");
		}
	};

	const profileImage =
		localStorage.getItem("accountType") === "professional" &&
		localStorage.getItem("professionalPhoto") !== "undefined"
			? localStorage.getItem("professionalPhoto")
			: localStorage.getItem("accountType") === "daycare" &&
			  localStorage.getItem("daycarePhoto") !== "undefined"
				? localStorage.getItem("daycarePhoto")
				: null;

	const hasProfileImage = Boolean(profileImage);

	const handleModuleClick = (value) => {
		setActivePill(value);
		setIsMenuOpen(false);
	};

	return (
		<header className={styles.header} ref={dropdownRef}>
			<button
				type="button"
				className={styles.mobileToggle}
				onClick={() => setIsMenuOpen((state) => !state)}
				aria-label={t("Menu")}
				aria-expanded={isMenuOpen}
			>
				<span className="material-icons">{isMenuOpen ? "close" : "menu"}</span>
			</button>

			<Link to="/" className={styles.brand} onClick={() => setIsMenuOpen(false)}>
				<img src={logo2} alt="Stepswatch" />
			</Link>

			<nav
				className={`${styles.moduleNav} ${
					isMenuOpen ? styles.moduleNavOpen : ""
				}`}
				aria-label={t("Modules")}
			>
				{allowedData.map((ele, index) => {
					const isActive = activePill === ele.value;

					if (ele.type) {
						return (
							<div className={styles.moduleDropdown} key={index}>
								<button
									type="button"
									className={`${styles.moduleButton} ${
										isActive ? styles.activeModule : ""
									}`}
									onClick={() => setActivePill(ele.value)}
								>
									{t(`${ele.name}`)}
									<span className="material-icons">expand_more</span>
								</button>
								<div className={styles.dropdownMenu}>
									{ele.data.map((dropdown, dropdownIndex) => (
										<NavLink
											key={dropdownIndex}
											to={dropdown.path}
											className={styles.dropdownItem}
											onClick={() => handleModuleClick(ele.value)}
										>
											{t(dropdown.name)}
										</NavLink>
									))}
								</div>
							</div>
						);
					}

					return (
						<NavLink
							key={index}
							to={ele.path}
							className={`${styles.moduleLink} ${
								isActive ? styles.activeModule : ""
							}`}
							onClick={() => handleModuleClick(ele.value)}
						>
							{t(`${ele.name}`)}
						</NavLink>
					);
				})}
			</nav>

			<div className={styles.rightTools}>
				<LanguageSelection />
				<DropDownMenu
					options={[
						{ name: `${t("profile")}`, click: gotoProfile },
						{ name: `${t("logout")}`, click: handleLogout },
					]}
					img={profileImage}
					icon={!hasProfileImage ? "user-circle" : null}
				/>
			</div>
		</header>
	);
}

export default Header;
